import styled from "styled-components";

import {
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  SCROLLBAR_STYLES,
} from "../../../constants/Styles";

export const Card = styled.div`
  min-width: 327px;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  ${CARD_BACKGROUND};
`;

export const Label = styled.div`
  padding: 0.5rem 0.25rem 0.25rem;
  color: ${COLORS.secondaryLight};
  display: flex;
  justify-content: space-between;
`;

export const FilterSearch = styled.div`
  padding: 0.25rem;
`;

export const FilterSearchInput = styled.input`
  width: 100%;
  border-radius: 0.5rem;
  color: ${COLORS.secondary};
  background-color: ${COLORS.inputGray};
  border: none;
`;

export const FilterValueList = styled.div`
  height: 120px;
  overflow-y: scroll;
  background-color: ${COLORS.inputGray};

  ${SCROLLBAR_STYLES};
`;

export const FilterValueListItem = styled.div<{
  isLastElement?: boolean;
  isSelected?: boolean;
}>`
  display: flex;
  padding: 0 0 0.25rem 0.25rem;
  align-items: center;

  ${({ isLastElement }) => isLastElement && `margin-bottom: 0;`}
  ${({ isSelected }) => isSelected && `background-color: ${COLORS.background};`}
`;

export const AppliedFiltersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const AppliedFilter = styled.div`
  border-radius: 100px;
  background: ${COLORS.badgeGray};
  padding: 0.25rem.75rem 0.25rem 0.5rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  gap: 0.25rem;
  height: 24px;
`;
